export const isMobileViewport = () =>
    typeof window !== "undefined" && window.matchMedia("(max-width: 768px)").matches;

// Scrolls the hero so the robot stands at pillar `i` (0-7) — a scroll anchor into the 3D walk
export const scrollToPillar = (i) => {
    const hero = document.querySelector('[data-testid="hero-section"]');
    if (!hero) return;
    const range = hero.offsetHeight - window.innerHeight;
    const top = hero.offsetTop + (Math.max(0, Math.min(7, i)) / 7) * range;
    window.scrollTo({ top, behavior: "smooth" });
};
